module.exports = __webpack_public_path__ + "img/icon-review-timeline.beb535c1.svg";